import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Whatsapp from './Whatsapp';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="main-wrapper page">
      <Navbar />

      <div className="content-wrapper">
        <div className="about-us" data-aos="fade-up">
          <div className="about-us-title text-center">
            <div className="container">
              <h1 className="heading-bold text-uppercase">Privacy Policy</h1>
            </div>
          </div>
        </div>

        <div className="privacy-policy-content container" data-aos="fade-up">
          <p className="privacy-policy-meta">
            Effective Date: July 1, 2026 &nbsp;|&nbsp; Last Updated: June 30, 2026
          </p>

          <p>
            LIT Alumni Association North America Chapter (&quot;LITAA NA,&quot; &quot;we,&quot;
            &quot;our,&quot; or &quot;us&quot;) is a registered 501(c)(3) nonprofit organization
            incorporated in the State of Texas (EIN: 39-2341136). We are committed to protecting the
            privacy of visitors to our website and members of our alumni community. This Privacy Policy
            explains what information we collect, how we use it, and your rights with respect to that
            information.
          </p>
          <p>
            By using our website or contacting us, you agree to the practices described in this Privacy
            Policy.
          </p>

          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide to us voluntarily, and limited information collected
            automatically when you visit our website.
          </p>
          <p><strong>Information you provide directly:</strong></p>
          <ul>
            <li>Name and email address submitted through our contact form</li>
            <li>Graduation year and academic discipline, if provided</li>
            <li>Reason for contact and any message content you submit</li>
            <li>Any additional information you choose to share when joining or making a donation inquiry</li>
          </ul>
          <p><strong>Information collected automatically:</strong></p>
          <ul>
            <li>Basic website usage data through standard web hosting analytics, if enabled</li>
            <li>Device type, browser type, and IP address — collected automatically by web servers</li>
          </ul>
          <p>
            We do not currently use advertising trackers, third-party behavioral analytics, or cookies
            beyond those necessary for basic website functionality.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect solely for the following purposes:</p>
          <ul>
            <li>To respond to inquiries submitted through our contact form</li>
            <li>To process membership registrations and maintain member records</li>
            <li>To communicate chapter news, event announcements, and updates to opted-in alumni</li>
            <li>To coordinate giving opportunities and donor communications</li>
            <li>To maintain records required for our nonprofit compliance obligations</li>
          </ul>
          <p>
            We do not sell, rent, trade, or share your personal information with third parties for
            marketing or commercial purposes, nor do we intend to do so in the future.
          </p>

          <h2>3. How We Share Your Information</h2>
          <p>
            We do not sell or commercially share personal information. We may share information only in
            the following limited circumstances:
          </p>
          <ul>
            <li>
              With LITAA (litalumni.org) — our global parent alumni body — for maintaining a unified
              alumni registry
            </li>
            <li>
              With service providers who assist us in operating the website or communicating with
              members (e.g. Mailchimp), bound to use information only on our behalf
            </li>
            <li>When required by law, court order, or government authority</li>
            <li>
              In the event of a merger, dissolution, or transfer of the organization&apos;s assets,
              as permitted under applicable nonprofit law
            </li>
            <li>With your explicit permission if a fellow registered member alumnus requests it</li>
          </ul>

          <h2>4. Donor Privacy</h2>
          <p>
            LITAA NA respects the privacy of our donors. We do not sell, share, or trade donor names,
            contact information, or giving history with any other organization; nor do we intend to do
            so in the future. Donor information is used solely to process contributions, provide tax
            acknowledgment letters, and communicate about supported projects.
          </p>
          <p>
            Donors who wish to remain anonymous may request anonymity at the time of their gift. We will
            honor such requests in all public communications while retaining records as required for IRS
            compliance.
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain personal information for as long as necessary to fulfill the purposes described in
            this policy, maintain membership records, and meet our legal and tax compliance obligations.
            Contact form submissions are retained only as long as needed to respond to and resolve the
            inquiry.
          </p>

          <h2>6. Security</h2>
          <p>
            We take reasonable precautions to protect personal information from unauthorized access,
            disclosure, or misuse. We limit internal access to personal data to chapter officers and
            volunteers who require it for chapter operations. However, no method of internet
            transmission or electronic storage is completely secure.
          </p>

          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate or incomplete information</li>
            <li>Request deletion of your information, subject to our legal retention obligations</li>
            <li>
              Opt out of email communications at any time via the unsubscribe link in any email, or by
              contacting us directly
            </li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at the email address listed in Section 10.
          </p>

          <h2>8. Minor&apos;s/Children&apos;s Privacy</h2>
          <p>
            Our website and services are not directed to individuals under the age of 18. We do not
            knowingly collect personal information from children. If you believe we have inadvertently
            collected such information, please contact us and we will promptly delete it.
          </p>

          <h2>9. Third-Party Links</h2>
          <p>
            Our website may contain links to external websites, including litalumni.org and litu.edu.in.
            This Privacy Policy applies only to our website. We are not responsible for the privacy
            practices of linked third-party sites.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have questions, concerns, or requests regarding this Privacy Policy or your personal
            information, please contact us:
          </p>
          <address className="privacy-policy-contact">
            LIT Alumni Association North America Chapter
            <br />
            11104 W Airport Blvd Ste 213, Stafford, TX 77477, USA
            <br />
            Email:{' '}
            <a href="mailto:globalalumni@litaana.org">globalalumni@litaana.org</a>
            <br />
            Website:{' '}
            <a href="https://www.litaana.org" target="_blank" rel="noopener noreferrer">
              www.litaana.org
            </a>
          </address>

          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. When we do, we will revise the
            &quot;Last Updated&quot; date at the top of this page. Continued use of our website
            following any update constitutes your acceptance of the revised policy.
          </p>

          <p className="privacy-policy-disclaimer">
            This Privacy Policy was drafted for internal review. It should be reviewed by qualified
            legal counsel before publication. LITAA NA does not warrant that this document constitutes
            legal advice.
          </p>
        </div>

        <Whatsapp />
      </div>

      <Footer />
    </div>
  );
}
